/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
//var lightbox = new PhotoSwipeLightbox({
//gallery: ".gallery--individual",
//children: "a",
//// dynamic import is not supported in UMD version
//pswpModule: PhotoSwipe,
//});
//lightbox.init();

document.addEventListener("DOMContentLoaded", function (event) {
  ScrollReveal().reveal(".article__content", {
    delay: 100,
    opacity: 0.9,
  });
});
